import { ComponentProps } from "react";
import { useSnackbar } from "notistack";
import { useModal } from "../../../components";
import { TimeInLieu, ApprovalStatus } from "../../../API";
import { useTimeInLieuLib } from "../../../lib";
import { ActionModal } from "./ActionModal";

export const useActionModals = () => {
  const { updateTimeInLieuRecord } = useTimeInLieuLib();
  const { enqueueSnackbar } = useSnackbar();
  const showSnackbar = (message: string, error = false) => {
    enqueueSnackbar(message, { variant: error ? "error" : "success" });
  };

  const postAction = (
    message: string,
    isError: boolean,
    callback: () => void
  ) => {
    showSnackbar(message, isError);
    callback();
  };

  const { showModal: showActionModal, hideModal } = useModal<
    ComponentProps<typeof ActionModal>,
    { row: TimeInLieu; status: ApprovalStatus }
  >({
    component: ActionModal,
    data: {
      onSubmit: ({ data }) =>
        updateTimeInLieuRecord(data, {
          onSuccess: () =>
            postAction(
              "Time in Lieu request has been updated.",
              false,
              hideModal
            ),
          onError: () =>
            postAction(
              "Error updating Time in Lieu request. Please try again in a few seconds",
              true,
              hideModal
            ),
        }),
      testID: "manage-request",
    },
  });

  return {
    showActionModal,
  };
};
